import React from "react";
import { X, Printer, Download } from "lucide-react";
import { Button } from "../ui/button";
import ReportBody from "./ReportBody";

const ReportPreview = ({ r, onClose, onDownload }) => {
  if (!r) return null;

  return (
    <div className="fixed inset-0 z-50 bg-[#f0f0f0] flex flex-col" data-testid="report-preview-container">
      {/* Action bar */}
      <div className="no-print sticky top-0 z-10 flex items-center justify-between px-4 h-14 bg-white/80 backdrop-blur-xl border-b border-slate-200">
        <button onClick={onClose} className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900" data-testid="report-close-btn">
          <X size={18} /> Close
        </button>
        <div className="text-xs font-semibold uppercase tracking-widest text-slate-400">Tax Computation Report</div>
        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={() => window.print()} className="gap-2 h-9" data-testid="report-print-btn"><Printer size={15} /> Print</Button>
          <Button onClick={onDownload} className="gap-2 h-9 bg-[#1877c9] hover:bg-[#0f5ea3]" data-testid="export-pdf-btn"><Download size={15} /> Download PDF</Button>
        </div>
      </div>

      {/* Scroll area */}
      <div className="report-scroll flex-1 overflow-auto py-8">
        <div className="a4-paper font-report max-w-[210mm] w-full mx-auto bg-white shadow-[0_8px_30px_rgb(0,0,0,0.06)] ring-1 ring-slate-200 p-[18mm]">
          <ReportBody r={r} />
        </div>
      </div>
    </div>
  );
};

export default ReportPreview;
